// @owners { team: patients }
import { createSelector } from 'reselect';
import getLastDismissedRatingUuid from './getLastDismissedRatingUuid';
import getPendingRating from './getPendingRating';

export const getShouldShowModal = createSelector(
  [getPendingRating, getLastDismissedRatingUuid],
  (pendingRating, lastDismissedRatingUuid) => {
    return !!pendingRating && pendingRating.uuid !== lastDismissedRatingUuid;
  },
);
